"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _uuid = _interopRequireDefault(require("uuid"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Tooltip = function Tooltip(props) {
  var children = props.children,
      delayHide = props.delayHide,
      delayShow = props.delayShow,
      effect = props.effect,
      offset = props.offset,
      tooltipId = props.tooltipId,
      tooltipBody = props.tooltipBody,
      placement = props.placement,
      tooltipIcon = props.tooltipIcon,
      id = props.id,
      classNames = props.classNames;

  var _useState = (0, _react.useState)(typeof tooltipId !== 'undefined' ? tooltipId : (0, _uuid.default)()),
      _useState2 = _slicedToArray(_useState, 1),
      myToolTipID = _useState2[0];

  var refContainer = (0, _react.useRef)(null); // Accessibility - the event and eventOff are set to allow ADA compatible working through keyboard events

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    "data-tip": true,
    "data-for": myToolTipID,
    role: "button",
    tabIndex: 0,
    className: (0, _classnames.default)('tooltip-component', classNames),
    id: id,
    ref: refContainer
  }, children), /*#__PURE__*/_react.default.createElement(_reactTooltip.default, {
    clickable: true,
    effect: effect,
    id: myToolTipID,
    delayHide: delayHide,
    delayShow: delayShow,
    place: placement,
    offset: offset,
    multiline: true,
    event: "focus mouseover",
    eventOff: "blur mouseout"
  }, tooltipIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: "tooltip_icon"
  }, tooltipIcon), /*#__PURE__*/_react.default.createElement("span", {
    className: "tooltip__body"
  }, tooltipBody)));
};

Tooltip.propTypes = {
  effect: _propTypes.default.oneOf(['float', 'solid']).isRequired,
  classNames: _propTypes.default.any.isRequired,
  id: _propTypes.default.string,
  placement: _propTypes.default.oneOf(['left', 'right', 'top', 'bottom']),
  delayHide: _propTypes.default.number,
  delayShow: _propTypes.default.number,
  tooltipId: _propTypes.default.string,
  tooltipBody: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.element, _propTypes.default.any, _propTypes.default.element]).isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]).isRequired,
  offset: _propTypes.default.any,
  tooltipIcon: _propTypes.default.node
};
var defaultProps = {
  effect: 'solid',
  classNames: {}
};
Tooltip.defaultProps = defaultProps;
var _default = Tooltip;
exports.default = _default;